import { Component, Optional, Inject, Injector } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, NG_ASYNC_VALIDATORS } from '@angular/forms';

import { InputBase } from '../../../base/input-base';

@Component({
    selector: 'aa-input-text2',
    templateUrl: './input-text2.component.html',
    styleUrls: [
        '../input.component.scss'
    ],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: InputText2Component,
            multi: true,
        }],
    standalone: false
})
export class InputText2Component extends InputBase<string>
{
    private static identifier = 0;

    constructor (
        injector: Injector,
        @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
        @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>
    )
    {
        super(injector);
        this.fieldId = `input-text2-${InputText2Component.identifier++}-id`;
    }
}
